export const messages = {
  en: {
    chainSupplier: {
      queryCondition: 'Query Conditions',
      productNamePlaceholder: 'Please enter product name',
      productIdPlaceholder: 'Please enter product ID',
      query: 'Query',
      productId: 'Product ID',
      productImage: 'Product Image',
      productCategory: 'Product Category',
      productName: 'Product Name',
      productUnit: 'Product Unit',
      sort: 'Sort',
      status: 'Status',
      createTime: 'Create Time',
      operation: 'Operation',
      onShelf: 'On Shelf',
      offShelf: 'Off Shelf',
      purchase: 'Purchase',
      purchaseOrder: 'Purchase Order',
      unit: 'Unit',
      productCover: 'Product Cover',
      orderSpecQuantity: 'Order Specification Quantity',
      specName: 'Specification Name',
      specValue: 'Specification Value',
      price: 'Price',
      purchaseQuantity: 'Purchase Quantity',
      pricingStrategy: 'Pricing Strategy',
      selectPricingStrategy: 'Select Pricing Strategy',
      remark: 'Remark',
      cancel: 'Cancel',
      save: 'Save',
      purchaseSuccess: 'Purchase Success'
    }
  },
  zh: {
    chainSupplier: {
      queryCondition: '查询条件',
      productNamePlaceholder: '请输入商品名称',
      productIdPlaceholder: '请输入商品编号',
      query: '查询',
      productId: '商品ID',
      productImage: '商品图片',
      productCategory: '商品分类',
      productName: '商品名称',
      productUnit: '商品单位',
      sort: '排序',
      status: '状态',
      createTime: '创建时间',
      operation: '操作',
      onShelf: '已上架',
      offShelf: '未上架',
      purchase: '采购',
      purchaseOrder: '集采下单',
      unit: '单位',
      productCover: '商品封面图',
      orderSpecQuantity: '下单规格数量',
      specName: '规格名称',
      specValue: '规格值',
      price: '价格',
      purchaseQuantity: '采购数量',
      pricingStrategy: '定价策略',
      selectPricingStrategy: '请选择价格策略',
      remark: '备注',
      cancel: '取消',
      save: '保存',
      purchaseSuccess: '采购成功'
    }
  }
}